import { render, staticRenderFns } from "./NewspapersDateVis.vue?vue&type=template&id=30bbbd28&scoped=true&"
import script from "./NewspapersDateVis.vue?vue&type=script&lang=js&"
export * from "./NewspapersDateVis.vue?vue&type=script&lang=js&"
import style0 from "./NewspapersDateVis.vue?vue&type=style&index=0&id=30bbbd28&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bbbd28",
  null
  
)

export default component.exports